// @ts-strict-ignore
import React from 'react'
import { History } from 'history'
import { withRouter, RouteComponentProps } from 'react-router'
import { routerMiddleware } from 'connected-react-router'
import { sendPathname } from '../logging/analytics'
import { history } from './history'
import { storeDeferredDeepLinkingURLIfNeeded } from '../platform/deferredDeepLinking'

export const middleware = routerMiddleware(history)

export let ionHistory: History

class IonicNavigation extends React.PureComponent<RouteComponentProps> {
	unListen: () => void

	pathname = ''
	hash = ''
	searchParams: Record<string, string> = {}

	componentDidMount() {
		// Fix for ionic router
		ionHistory = this.props.history

		sendPathname(ionHistory.location.pathname, undefined, ionHistory.location.hash, ionHistory.location.search)
		storeDeferredDeepLinkingURLIfNeeded()

		this.unListen = ionHistory.listen(({ pathname, state, hash, search }) => {
			if (hash === '#transcript' || this.hash === '#transcript') {
				return
			}

			const searchParams = Object.fromEntries(new URLSearchParams(search).entries())

			// prevent multiple sending the same page view event
			// Use `areSearchParamsEqual` to check if it's still the same params but in different order (seen with map view)
			if (pathname !== this.pathname || hash !== this.hash || !this.areSearchParamsEqual(searchParams, this.searchParams)) {
				sendPathname(pathname, state, hash, search)
				storeDeferredDeepLinkingURLIfNeeded()
				this.pathname = pathname
				this.hash = hash
				this.searchParams = searchParams
			}
		})
	}

	componentWillUnmount() {
		this.unListen()
	}

	areSearchParamsEqual(searchParams1: Record<string, string>, searchParams2: Record<string, string>) {
		const keys1 = Object.keys(searchParams1)
		const keys2 = Object.keys(searchParams2)

		if (keys1.length !== keys2.length) {
			return false
		}

		for (const key of keys1) {
			if (searchParams1[key] !== searchParams2[key]) {
				return false
			}
		}

		return true
	}

	render() {
		return null
	}
}

export default withRouter(IonicNavigation)
